const getModuleContents = (module, contents, transform, moduleKey) =>
  contents
    .filter(content =>
      content.fields.some(
        field =>
          field.title === 'MODULE' &&
          module.split('|').indexOf(field.value.trim()) > -1
      )
    )
    .map(
      item =>
        transform
          ? setFieldKeys(
            getModuleDetails(item.fields, !transform, moduleKey).fields
          )
          : getModuleDetails(item.fields, !transform, moduleKey).fields
    )

const getMeta = contents => {
  const metaData = {}

  contents.some(content =>
    content.fields.some(field => {
      if (field.title === 'MetaData') {
        metaData.title = field.fields[0].value
        metaData.description = field.fields[1].value
      }

      return field.title === 'MetaData';
    })
  )

  return metaData
};

const getModuleDetails = (fields, isNav, moduleKey) => {
  let itemIndex = 0

  fields.some((field, index) => {
    itemIndex = index
    return field.title === moduleKey
  })

  return fields[itemIndex]
};

const setFieldKeys = fields =>
  fields.reduce((total, current) => {
    if (!current.title) {
      return total
    }
    if (current.title === 'IMAGE FILE NAME' && total[current.title]) {
      total[current.title] = [total[current.title], current]
    } else {
      total[current.title] = current
    }
    return total
  }, {})

export default (
  modules,
  contents,
  transform = true,
  moduleKey = 'MODULE DETAILS'
) => {
  const finalContents = {}

  modules.forEach(module => {
    finalContents[module.title] = getModuleContents(
      module.name,
      contents,
      transform,
      moduleKey
    )
  })

  finalContents.meta = getMeta(contents)
  return finalContents
};



// WEBPACK FOOTER //
// ./src/utils/build-json.js